<div class="text">
  <div class="text__label">
    <ion-label>{{question.label}}</ion-label>
  </div>
  <div class="text-input-group" style="display:block">
    <div class="form-group">
      <input type="text" class="form-control" [value]="value" [name]="question.key" [placeholder]="question.label"
        readonly />
    </div>
  </div>
</div>
